<template>
  <ClientOnly>
    <Teleport to="body">
      <TsModal v-if="!isMobile" v-model:visible="productStore.is_confirmation_modal_visible" append-class="overflow-y-auto">
        <template #modal-content>
        <TsModalTrolleyItemConfirmation
           data-testid="trolley-add-ons-recommendations"
          :product="trolleyStore.current_add_on_item || productStore.product" :quantity="productStore.quantity_to_add"
          :method="productStore.delivery_method" :branch="branchStore.lastSavedBranch?.name"
          @hide="productStore.is_confirmation_modal_visible = false"
          @add-recommendation-to-trolley="(item) => handleRecommendationAddToTrolley(item)"
          @go-to-trolley="handleTrolleyPageNavigation" />
        </template>
      </TsModal>

      <TsDrawer position="bottom" v-model:visible="productStore.is_confirmation_modal_visible" append-class="overflow-y-auto"  v-else>
        <TsModalTrolleyItemConfirmation
          data-testid="trolley-add-ons-recommendations"
          :product="trolleyStore.current_add_on_item || productStore.product" :quantity="productStore.quantity_to_add"
          :method="productStore.delivery_method" :branch="branchStore.lastSavedBranch?.name"
          @hide="productStore.is_confirmation_modal_visible = false"
          @add-recommendation-to-trolley="(item) => handleRecommendationAddToTrolley(item)"
          @go-to-trolley="handleTrolleyPageNavigation" />
      </TsDrawer>
      <TsPageLoader />
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
import { DeliveryMethodCodes } from "~/assets/constants/ecomApi";
import type { Product } from "~/types/ecom/product/product.type";
import { TrolleyChannel } from "~/types/ecom/trolley/trolley-map";

const TsModalTrolleyItemConfirmation = defineAsyncComponent(
  () => import('~/components/organisms/TsModalTrolleyItemConfirmation.vue')
);

const TsDrawer = defineAsyncComponent(
  () => import('~/components/organisms/TsDrawer.vue')
);

const TsPageLoader = defineAsyncComponent(
  () => import('~/components/organisms/TsPageLoader.vue')
);

const isMobile = useDevice().isMobile;

const trolleyStore = useTrolleyStore();
const productStore = useProductStore();
const branchStore = useBranchStore();
const localePath = useLocalePath();
const rootStore = useRootStore();

async function handleTrolleyPageNavigation() {
  productStore.is_confirmation_modal_visible = false;
  await navigateTo(localePath("/trolley"));
}

async function handleRecommendationAddToTrolley(addOnItem: Product) {

  rootStore.is_page_loading = true;
  productStore.delivery_method = "Delivery";
  const response = await trolleyStore.dispatchItemToTrolley(
    addOnItem.code,
    1,
    TrolleyChannel.Delivery,
    DeliveryMethodCodes.Delivery,
    false, true
  );

  if (response) {
    trolleyStore.current_add_on_item = addOnItem;
  }
  rootStore.is_page_loading = false;

}
</script>
